import { gql } from '@apollo/client'

import { SIMPLE_USER_FRAGMENT } from '../../../common/graphql/fragments'

const MENU_CURATION_TASK_HISTORY_QUERY = gql`
  query history($filters: HistoryFiltersInput!, $pagination: PaginationInput!) {
    history(filters: $filters, pagination: $pagination) {
      total
      result {
        id
        createdAt
        user {
          ...SimpleUserFragment
        }
        description
      }
    }
  }
  ${SIMPLE_USER_FRAGMENT}
`

export default MENU_CURATION_TASK_HISTORY_QUERY
